import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaLink } from 'react-icons/fa'
import { Button } from '@chakra-ui/react'
import { useDisclosure } from '@chakra-ui/react'

import {
    AppointmentFieldsFragment,
    ChatFieldsFragment,
} from '~graphql/generated/graphql'
import SendFormModal from './modal'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'

interface Props {
    chat: ChatFieldsFragment
    text: string
    setText: (text: string) => void
    /** Appointment to pre-select for appointment-specific links. */
    appointment?: AppointmentFieldsFragment
    /** Force icon-only display regardless of breakpoint. */
    compact?: boolean
}

export default function AddLinkButton({
    chat,
    text,
    setText,
    appointment,
    compact = false,
}: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    if (!chat.clinic) return null

    return (
        <>
            <Button
                leftIcon={<Icon as={FaLink} fontSize="xs" />}
                size="xs"
                borderWidth={1}
                borderColor="gray.200"
                h="28px"
                rounded="full"
                variant="subtle"
                onClick={onOpen}
                display={
                    compact
                        ? 'none'
                        : {
                              base: 'none',
                              lg: 'flex',
                          }
                }
            >
                Add link/form
            </Button>
            <IconButtonWithTooltip
                icon={<Icon as={FaLink} fontSize="xs" />}
                label="Add link/form"
                size="xs"
                rounded="full"
                variant="subtle"
                borderWidth={1}
                borderColor="gray.200"
                tooltipOverrides={{
                    placement: 'top',
                }}
                display={
                    compact
                        ? 'flex'
                        : {
                              base: 'flex',
                              lg: 'none',
                          }
                }
                onClick={onOpen}
            />
            <SendFormModal
                isOpen={isOpen}
                onClose={onClose}
                clinic={chat.clinic}
                client={chat.client}
                appointment={appointment}
                text={text}
                setText={setText}
            />
        </>
    )
}
